import React from "react";
import './MadhyaPradesh.css';

export default function MadhyaPradesh() {
  return (
    <section>
    <div>
      <h1>Madhya Pradesh</h1>
      <p>Welcome to the Madhya Pradesh page!</p>
    </div>
  </section>
  );
}